export default __webpack_public_path__ + "static/media/hotel_1.b7d6c6e2.png";